import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-buttons',
  templateUrl: './card-buttons.component.html',
  styleUrls: ['./card-buttons.component.scss']
})
export class CardButtonsComponent implements OnInit {
  // @Input()

  constructor() { }

  ngOnInit(): void {
  }

}
